import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateVendorContact } from '../../../state/vendorSlice';

const SecondaryPhoneEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentVendor } = useAppSelector(state => state.vendor);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateVendorContact({ secondaryPhone: event.target.value }));
  };

  return (
    <TextField
      label="Phone"
      size="small"
      fullWidth
      value={currentVendor?.secondaryPhone || ''}
      onChange={handleChange}
    />
  );
};

export default SecondaryPhoneEdit;
